<div
  class="container-fluid text-light-gray wow fadeIn"
  data-wow-delay="0.1s">
  <div class="container mt-0">
    <div class="row g-5">
      <div class="col-md-6 mx-auto">
        <h4 class="mb-1 text-yellow mb-1 text-center py-3">
          {{ pageData.title }}
        </h4>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="copyright py-1" style="font-size: 12px">
      <div class="row">
        <p class="text-center text-uppercase">
          {{ pageData.pageDescription }}
        </p>
      </div>
    </div>
  </div>
</div>

